import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { marked } from 'marked';
import { Router } from '@angular/router';
import { CallService, CallState } from './call.service';
import { Subscription } from 'rxjs';
import { AppService } from '../../../../app.service';

@Component({
  selector: 'app-chatbox-smartdocs',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './chatbox-smartdocs.component.html',
  styleUrl: './chatbox-smartdocs.component.scss',
})
export class ChatboxSmartdocsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('ccpDiv') public ccpDiv!: ElementRef;
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  @ViewChild('remoteAudio') private remoteAudio!: ElementRef<HTMLAudioElement>;
  private clickListener: (() => void) | undefined;
  private languageButtonDisabled = false;
  resendCountdown = 0;
  private intervalId: any;
  chooseType: boolean = true;
  mobShow: boolean = false;
  chatScreenShow = false;
  showIframe = false;
  ccpInitialized = false;
  ccpLoading = false;

  otpAuthHide: boolean = true;
  form: FormGroup;
  chatType: any = 'Agent';
  currentDateTime = new Date();

  chatMessages: any = [
    {
      sender: 'you',
      text: `
   <div class="ms-3">
  <div class="d-flex align-items-center mb-1" style="gap: 6px;">
    <span class="fw-bold text-primary" style="font-size: 10px; letter-spacing: 1.2px; text-transform: uppercase; opacity: 0.8;">
      MI IDP Intelligence
    </span>
  </div>
  
  <div class="bg-white border-0 shadow-sm p-3"
       style="border-top-left-radius: 2px !important; border-radius: 14px; max-width: 340px; border-left: 4px solid #1e40af;">
    <p class="mb-0 text-dark" style="line-height: 1.6; font-size: 13.5px; color: #374151 !important;">
      Welcome. I have indexed the <strong>uploaded documents</strong> and am ready to assist. 
      Provide a <strong>specific topic</strong>, and I will extract the precise information you need from the available records.
    </p>
  </div>
</div>
    `,
    },
  ];
  ticketMessages: any = [];
  chatBox: any = '';
  CurrentDescription: string = '';
  getDescription: boolean = false;
  buttonDisable: boolean = false;
  setLoading = false;
  currentDepartmentId: any = '';
  currentAgeGroup: any = '';
  chatEnd: boolean = false;
  textBoxDisable: boolean = true;
  showOptions: boolean = false;
  showAgeOptions: boolean = false;
  showSchemeOptions: boolean = false;
  currentSchemeId: any = '';
  chatBubbleHtml = `
     <div class="ms-3">
  <div class="d-flex align-items-center mb-1" style="gap: 6px;">
    <span class="fw-bold text-primary" style="font-size: 10px; letter-spacing: 1.2px; text-transform: uppercase; opacity: 0.8;">
      MI IDP Intelligence
    </span>
  </div>
  
  <div class="bg-white border-0 shadow-sm p-3"
       style="border-top-left-radius: 2px !important; border-radius: 14px; max-width: 340px; border-left: 4px solid #1e40af;">
    <p class="mb-0 text-dark" style="line-height: 1.6; font-size: 13.5px; color: #374151 !important;">
      Welcome. I have indexed the <strong>uploaded documents</strong> and am ready to assist. 
      Provide a <strong>specific topic</strong>, and I will extract the precise information you need from the available records.
    </p>
  </div>
</div>
    `;

  currentLanguage: any = 'English'
  departments: any = [];
  schemeOptions: any = [];
  count: any = 0;
  currentDepartmentName: any = '';
  currentSchemeName: any = '';
  districtSelection: boolean = false;
  districtRecord: any = [];
  queryAsked: any = '';
  contactNumber: string = '';

  callState: CallState = 'idle';
  callTimer = '00:00';
  callMuted = false;
  callError = '';
  private callTimerInterval: any;
  private callSubs: Subscription[] = [];
  private pendingEmergencyEscalation = false;
  /** Fixed array for visualizer bars to avoid new array every change detection */
  readonly visualizerBars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    public router: Router,
    private apiService: AppService,
    private callService: CallService
  ) {
    this.form = this.fb.group({
      mobileNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      otp: ['', Validators.required],
      chatType: [null, Validators.required],
    });
    // Initialize department list mock
    this.getAllDepartments();
  }

  ngOnInit() {
    this.callSubs.push(
      this.callService.callState$.subscribe(s => {
        this.callState = s;
        if (s === 'connected') this.startCallTimer();
        else this.stopCallTimer();
        this.cdr.markForCheck();
      }),
      this.callService.isMuted$.subscribe(m => {
        this.callMuted = m;
        this.cdr.markForCheck();
      }),
      this.callService.error$.subscribe(e => {
        this.callError = e;
        this.cdr.markForCheck();
      })
    );
    let storedData: any = sessionStorage.getItem('chatState');
    if (storedData) {
      try {
        storedData = JSON.parse(storedData);
        this.otpAuthHide = storedData.otpAuthHide;
        this.chooseType = storedData.chooseType;
        this.mobShow = storedData.mobShow;
        this.chatEnd = storedData.chatEnd;
        this.chatType = storedData.chatType;
        this.chatMessages = storedData.chatMessages;
        this.ticketMessages = storedData.ticketMessages;
        this.getDescription = storedData.getDescription;
        this.buttonDisable = storedData.buttonDisable;
        this.currentDepartmentId = storedData.currentDepartmentId;
        this.currentDepartmentName = storedData.currentDepartmentName;
        this.currentSchemeName = storedData.currentSchemeName;
        this.currentAgeGroup = storedData.currentAgeGroup;
        this.currentLanguage = storedData.currentLanguage;
        this.textBoxDisable = storedData.textBoxDisable;
        this.districtRecord = storedData.districtRecord;
        this.districtSelection = storedData.districtSelection;

        // Restore input phase state if needed, though simple checks on last message might be better
        // For now, let's infer or default to false to avoid getting stuck

        if (this.chatEnd == true) {
          this.resetChat();
        }
      } catch (e) {
        console.error('Error parsing stored chat state', e);
      }
    }
  }

  toggleIframe() {
    this.showIframe = !this.showIframe;
    if (this.showIframe) {
      this.ccpLoading = true;
      setTimeout(() => {
        this.ccpInit();
        this.ccpInitialized = true;
      }, 100);
    }
  }

  startVoiceCall() {
    const audio = this.remoteAudio?.nativeElement;
    if (audio) this.callService.startCall(audio);
  }

  toggleCallMute() {
    this.callService.toggleMute();
  }

  endVoiceCall() {
    this.callService.endCall();
  }

  private callTimerStart = 0;
  private startCallTimer() {
    this.callTimerStart = Date.now();
    this.callTimer = '00:00';
    this.callTimerInterval = setInterval(() => {
      const sec = Math.floor((Date.now() - this.callTimerStart) / 1000);
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      this.callTimer = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      this.cdr.markForCheck();
    }, 1000);
  }

  private stopCallTimer() {
    if (this.callTimerInterval) {
      clearInterval(this.callTimerInterval);
      this.callTimerInterval = null;
    }
    this.callTimer = '00:00';
  }

  ccpInit() {
    if (!this.ccpDiv) {
      console.warn('ccpDiv not found');
      this.ccpLoading = false;
      return;
    }
    connect.core.initCCP(this.ccpDiv.nativeElement, {
      ccpUrl: 'https://tscti-demo.my.connect.aws/ccp-v2',
      loginPopup: true,
      loginPopupAutoClose: true,
      region: 'us-east-1',
      softphone: { allowFramedSoftphone: true },
    });

    // Hide loader after a short buffer to allow dialer to render
    setTimeout(() => {
      this.ccpLoading = false;
    }, 3000);
    let comp: any = this;
    connect.agent((agent) => {
      // this.agentStatus = agent.getState().name;
      // console.log('Initial agent status:', this.agentStatus);
    });
    connect.contact((contact) => {
      console.log('contact', contact);
      contact.onConnected((contact2) => {
        console.log('connected', contact2);
        const connection = contact2.getActiveInitialConnection();
        if (connection && connection.getEndpoint()) {
          comp.contactNumber = connection.getEndpoint().phoneNumber;
          const contactNumber = comp.contactNumber;
        } else {
          console.warn('No active connection or endpoint found.');
        }

        if (contact2.getActiveInitialConnection()?.getEndpoint()) {
          connect.agent((agent) => {
            console.log('agent', agent.getName());
          });

          contact2.onEnded((end) => {
            console.log('end', end);
          });
        } else {
          console.log('This is an existing contact for this agent');
        }
      });
    });
  }

  resetChat() {
    this.otpAuthHide = true;
    this.chooseType = true;
    this.mobShow = false;
    this.chatType = 'Agent';
    this.chatMessages = [
      {
        sender: 'you',
        text: `
     <div class="ms-3">
  <div class="d-flex align-items-center mb-1" style="gap: 6px;">
    <span class="fw-bold text-primary" style="font-size: 10px; letter-spacing: 1.2px; text-transform: uppercase; opacity: 0.8;">
      MI IDP Intelligence
    </span>
  </div>
  
  <div class="bg-white border-0 shadow-sm p-3"
       style="border-top-left-radius: 2px !important; border-radius: 14px; max-width: 340px; border-left: 4px solid #1e40af;">
    <p class="mb-0 text-dark" style="line-height: 1.6; font-size: 13.5px; color: #374151 !important;">
      Welcome. I have indexed the <strong>uploaded documents</strong> and am ready to assist. 
      Provide a <strong>specific topic</strong>, and I will extract the precise information you need from the available records.
    </p>
  </div>
</div>
    `,
      },
    ];
    this.ticketMessages = [];
    this.chatEnd = false;
    this.getDescription = false;
    this.buttonDisable = false;
    this.currentDepartmentId = '';
    this.currentDepartmentName = '';
    this.currentSchemeName = '';
    this.currentAgeGroup = '';
    this.currentLanguage = '';
    this.textBoxDisable = false;
    sessionStorage.removeItem('chatState');
    sessionStorage.removeItem('chatSessionId');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollToBottom();
    }, 500);

    // Using mousedown instead of click to bypass focus-related issues
    // and using Renderer2 for better Angular integration/cleanup
    this.clickListener = this.renderer.listen(
      'document',
      'mousedown',
      (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const btn = target.closest('.btn-language') as HTMLElement | null;
        if (btn) {
          if (this.languageButtonDisabled) return;
          this.languageButtonDisabled = true;
          // Visually disable all language buttons
          document.querySelectorAll('.btn-language').forEach((b) => {
            (b as HTMLButtonElement).disabled = true;
            (b as HTMLButtonElement).style.opacity = '0.6';
            (b as HTMLButtonElement).style.cursor = 'not-allowed';
          });
          const lang = btn.getAttribute('data-lang');
          const display = btn.getAttribute('data-display');
          this.ngZone.run(() => {
            this.setLanguage(lang, display);
          });
          // Re-enable after 2 seconds
          setTimeout(() => {
            this.languageButtonDisabled = false;
            document.querySelectorAll('.btn-language').forEach((b) => {
              (b as HTMLButtonElement).disabled = false;
              (b as HTMLButtonElement).style.opacity = '';
              (b as HTMLButtonElement).style.cursor = '';
            });
          }, 2000);
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.clickListener) this.clickListener();
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.callTimerInterval) clearInterval(this.callTimerInterval);
    this.callSubs.forEach(s => s.unsubscribe());
  }

  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  scrollToBottom(): void {
    try {
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop =
          this.chatContainer.nativeElement.scrollHeight;
      }
    } catch (err) {
      // Ignore scroll errors
    }
  }

  setLanguage(lang: any, langFormat: any) {
    this.currentLanguage = lang;
    this.chatMessages.push({ sender: 'me', text: langFormat });
    this.chatType = 'Agent';

    setTimeout(() => {
      if (this.currentLanguage === 'English') {
        this.chatMessages.push({
          sender: 'you',
          text: 'You can now chat with our AI Assistant. How can I help you today?',
        });
      } else {
        this.chatMessages.push({
          sender: 'you',
          text: 'Ahora puedes chatear con nuestro asistente de IA. ¿En qué puedo ayudarte hoy?',
        });
      }
      this.setSessionMessages();
      this.scrollToBottom();
    }, 500);
  }

  chatVisibility() {
    this.chatScreenShow = !this.chatScreenShow;
    setTimeout(() => this.scrollToBottom(), 100);
  }

  setSessionMessages() {
    const data = {
      otpAuthHide: this.otpAuthHide,
      chooseType: this.chooseType,
      mobShow: this.mobShow,
      chatEnd: this.chatEnd,
      chatType: this.chatType,
      chatMessages: this.chatMessages,
      ticketMessages: this.ticketMessages,
      getDescription: this.getDescription,
      buttonDisable: this.buttonDisable,
      currentDepartmentId: this.currentDepartmentId,
      currentAgeGroup: this.currentAgeGroup,
      currentLanguage: this.currentLanguage,
      textBoxDisable: this.textBoxDisable,
      currentDepartmentName: this.currentDepartmentName,
      currentSchemeName: this.currentSchemeName,
      districtSelection: this.districtSelection,
      districtRecord: this.districtRecord,
    };
    sessionStorage.setItem('chatState', JSON.stringify(data));
  }

  sendMessage() {
    const userMessage = (this.chatBox ?? '').toString().trim();
    if (!userMessage || this.chatEnd) {
      return;
    }

    // Handle pending emergency confirmation first
    if (this.pendingEmergencyEscalation) {
      this.pendingEmergencyEscalation = false;
      const answer = userMessage.toLowerCase();
      const wantsCall = answer.startsWith('y');

      if (wantsCall) {
        if (!this.showIframe) {
          this.toggleIframe();
        }
        setTimeout(() => {
          const audio = this.remoteAudio?.nativeElement;
          if (audio && this.callState === 'idle') {
            this.callService.startEmergencyCall(audio, '1a94e09a-9876-41a0-a839-9883a31aa52f');
          }
        }, 300);

        this.chatMessages.push({
          sender: 'you',
          text: 'Connecting you to a live agent now. Please stay on the line.',
          bot: true,
        });
        this.setSessionMessages();
        this.scrollToBottom();

        // Do NOT trigger knowledge search for this confirmation message
        this.chatMessages.push({ sender: 'me', text: this.chatBox });
        this.CurrentDescription = userMessage;
        this.chatBox = '';
        return;
      }
      // continue normal flow below so message is still stored
    }

    this.chatMessages.push({ sender: 'me', text: this.chatBox });
    this.CurrentDescription = userMessage;
    this.chatBox = '';
    this.setSessionMessages();
    setTimeout(() => this.scrollToBottom(), 100);

    // For emergency-looking messages, ask for confirmation before escalating
    if (this.isEmergencyMessage(userMessage)) {
      this.chatMessages.push({
        sender: 'you',
        text: 'This sounds like an emergency. Would you like me to connect you to a live agent now?',
        bot: true,
      });
      this.pendingEmergencyEscalation = true;
      this.setSessionMessages();
      this.scrollToBottom();
      return;
    }

    // If agent user mentions an emergency scenario, auto-open voice assistant
    if (this.isEmergencyMessage(userMessage)) {
      if (!this.showIframe) {
        this.toggleIframe();
      }
      setTimeout(() => {
        if (this.callState === 'idle') {
          this.startVoiceCall();
        }
      }, 300);
    }

    if (this.chatType == 'Agent') {
      this.setLoading = true;

      let sessionId = sessionStorage.getItem('chatSessionId');
      if (!sessionId) {
        sessionId = 'chat-' + crypto.randomUUID();
        sessionStorage.setItem('chatSessionId', sessionId);
      }

      const payload = {
        query: userMessage || "",
      };

      this.apiService.postApiAgentChatBot(payload).subscribe({
        next: (response: any) => {
          this.setLoading = false;
          const answer = response?.answer ?? response?.response ?? response?.message;
          if (answer) {
            const rawAnswer = typeof answer === 'string' ? answer : String(answer);
            this.chatMessages.push({
              sender: 'you',
              text: marked.parse(rawAnswer),
              pdf_links: response?.pdf_links || [],
              bot: true,
            });
          } else {
            const errorMsg = this.currentLanguage === 'Spanish'
              ? "Lo siento, no pude procesar esa solicitud."
              : "I'm sorry, I couldn't process that request.";
            this.chatMessages.push({
              sender: 'you',
              text: errorMsg,
              bot: false,
            });
          }
          this.setSessionMessages();
          this.scrollToBottom();
        },
        error: (err) => {
          this.setLoading = false;
          console.error('ChatBot API Error:', err);
          const backendMsg = err?.error?.error || err?.error?.message || err?.message;
          const isConnectionRefused = err?.status === 0 || err?.status === undefined;
          let errorMsg: string;
          if (isConnectionRefused) {
            errorMsg = this.currentLanguage === 'Spanish'
              ? 'No se pudo conectar al servidor. Verifique que la aplicación esté en ejecución.'
              : 'Could not connect to server. Please ensure the backend is running.';
          } else {
            errorMsg = this.currentLanguage === 'Spanish'
              ? "Lo siento, tengo problemas para conectarme en este momento. Por favor, inténtelo de nuevo más tarde."
              : "Sorry, I'm having trouble connecting right now. Please try again later.";
          }
          this.chatMessages.push({
            sender: 'you',
            text: errorMsg,
            bot: false,
          });
          this.setSessionMessages();
          this.scrollToBottom();
        }
      });
    }
  }

  onEndChat() {
    this.chatEnd = true;
    this.setSessionMessages();
    setTimeout(() => {
      this.resetChat();
    }, 3000);
  }

  generateOtp() {
    this.mobShow = false;
    this.startResendTimer();
  }

  startResendTimer() {
    this.resendCountdown = 30;
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      if (this.resendCountdown > 0) this.resendCountdown--;
      else clearInterval(this.intervalId);
    }, 1000);
  }

  resendOtp() {
    this.startResendTimer();
  }

  submitAuth() {
    this.otpAuthHide = true;
    this.chatType = 'Agent';
    this.chatMessages.push({
      sender: 'you',
      text: 'Authentication successful. How can I help you today?',
    });
    this.setSessionMessages();
  }

  getAllDepartments() {
    this.departments = [
      {
        SerialNumber: 1,
        Department: { Id: '1', ShortNameEng: 'Police', ShortNameHin: 'पुलिस' },
      },
      {
        SerialNumber: 2,
        Department: {
          Id: '2',
          ShortNameEng: 'Public Works',
          ShortNameHin: 'लोक निर्माण',
        },
      },
    ];
  }

  goBack() {
    this.resetChat();
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  autoGrow(element: any) {
    element.style.height = 'auto';
    element.style.height = element.scrollHeight + 'px';
  }

  contactUs() {
    window.location.href = 'https://www.michigan.gov/';
  }



  /** Detect if a user's message sounds like an emergency that should be escalated to a live agent */
  private isEmergencyMessage(text: string | null | undefined): boolean {
    if (!text) {
      return false;
    }
    const lower = text.toLowerCase();

    const emergencyKeywords = [
      'fire',
      'on fire',
      'emergency',
      'life-threatening',
      'life threatening',
      'heart attack',
      'stroke',
      'unconscious',
      'not breathing',
      'bleeding',
      'accident',
      'car crash',
      'crash',
      'robbery',
      'theft',
      'stolen',
      'shooting',
      'gunshot',
      'violence',
      'domestic abuse',
      'kidnapped',
      'kidnapping',
      'murder',
      'suicide',
      'i want to die',
      'kill myself',
      '911',
      'call 911'
    ];

    return emergencyKeywords.some(k => lower.includes(k));
  }
}
